import * as React from 'react';

export const SimilarOffersAnchor = (props: React.PropsWithChildren<{}>) => {
  return <div id="similarOffers">{props.children}</div>;
};
